import StayHeadFR from '../components/stay/StayHeadFR';
import StayContent from '../components/stay/StayContent';
import FrenchPage from '../components/lifecycle/FrenchPage';

export default function Facilities() { 
  return (
    <>
      <FrenchPage />
      <StayHeadFR />
      <StayContent />
    </>
  );
}